/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

/**
 * Enum for encounter start types
 */
export type EncounterStartType =
  (typeof EncounterStartType)[keyof typeof EncounterStartType];

export const EncounterStartType = {
  TEXT_BASED: "TEXT_BASED",
  AUDIOVISUAL: "AUDIOVISUAL",
  ASYNC_DX: "ASYNC_DX",
  ASYNC_RX: "ASYNC_RX",
  RX_RENEWAL: "RX_RENEWAL",
} as const;
